import type { CohesionGlobal } from '@strata-monorepo/shared-types/src/window'
import type { EnrichCustomerResponse } from '@strata-monorepo/shared-types'

import { getStrataApiBaseUrl } from '@strata-monorepo/utils/getStrataApiBaseUrl'
import { withRetry } from '@strata-monorepo/shared-ui/utils/retryUtil'
import { store } from '@strata-monorepo/find-my-plan/lib/store/useStore'
import { createAppropriateMetricsClient } from '../hooks/useMetrics'
import type { BillEntryData } from '@strata-monorepo/shared-ui/components/BillEntry/BillEntry'

const consumptionPrediction = async (
  cohesionData: CohesionGlobal,
  enrichedAddressData: EnrichCustomerResponse,
  allEntries?: BillEntryData[],
) => {
  try {
    const baseUrl = getStrataApiBaseUrl()
    const url = `${baseUrl}/api/v1/ds/consumption-prediction`

    const { metricsClient, isMetricsProviderLoaded } = store.getState().metrics
    const client = isMetricsProviderLoaded ? metricsClient : createAppropriateMetricsClient()

    const { result: res } = await withRetry(
      async () => {
        return await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            webContext: cohesionData.webContext,
            enrichedCustomer: enrichedAddressData.results,
            billData:
              allEntries && allEntries.length > 0
                ? {
                    bills: allEntries,
                  }
                : null,
          }),
        })
      },
      {
        maxRetries: 3,
        baseDelay: 500,
        logAttempts: false,
      },
      { requestName: 'FetchConsumptionPrediction', metricsClient: client },
    )
    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`)
    }
    return await res.json()
  } catch (error) {
    throw error
  }
}

export default consumptionPrediction
